/**
 * Generated runtime TestId mirror for frontend/src/components/AttributeAuthorityBadge.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AttributeAuthorityBadgeTestIds = {
  attributeAuthorityBadge: "attribute-authority-badge",
  releaseAuthorityCancel: "release-authority-cancel",
  releaseAuthorityConfirm: "release-authority-confirm",
  releaseAuthorityDialog: "release-authority-dialog",
  transferAuthorityCancel: "transfer-authority-cancel",
  transferAuthorityConfirm: "transfer-authority-confirm",
  transferAuthorityDialog: "transfer-authority-dialog",
  transferAuthorityNoSources: "transfer-authority-no-sources",
  transferAuthorityTargetTrigger: "transfer-authority-target-trigger",
  menu: (root: string) => `${root}-menu`,
  release: (root: string) => `${root}-release`,
  transfer: (root: string) => `${root}-transfer`,
  transferAuthorityTarget: (src_targetSystemId: string) => `transfer-authority-target-${src_targetSystemId}`,
  transferAuthorityTargetPrefix: () => "transfer-authority-target-" as TestIdPrefix
} as const;
